import { createAsyncThunk } from '@reduxjs/toolkit';
import { TPreviewDocumentRequest } from '~/store/types.ts';
import api from '~/libs/api';
import { buildPreviewHtmlUrl, htmlContent } from '~/helpers/htmlContent';
import { safeWindowOpen } from '~/helpers/safeUrlOpen.ts';
import { thunkErrorHandler } from '~/store/utils.ts';

export const previewDocumentRemoteBanking = createAsyncThunk<void, TPreviewDocumentRequest>(
  'remoteBankingContacts/documentPreviewIIT',
  async ({ applicationId, token, idDoc, fileName }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };
      const { data } = await api.get(
        `/remote-banking-contacts/applications/${applicationId}/documents/${idDoc}/preview`,
        {
          headers,
        }
      );
      const fileURL = URL.createObjectURL(data);

      const htmlBlob = new Blob([htmlContent(fileURL, fileName)], { type: 'text/html' });
      const htmlURL = URL.createObjectURL(htmlBlob);
      const previewURL = buildPreviewHtmlUrl(htmlURL, fileName);

      safeWindowOpen(previewURL);

      setTimeout(() => URL.revokeObjectURL(htmlURL), 2000);
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
